import script from "./ModalDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalDialog.vue?vue&type=script&setup=true&lang=ts"

import "./ModalDialog.vue?vue&type=style&index=0&id=5d084e3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d084e3a"]])

export default __exports__